/**
 * kult-pdf.js — kleinster PDF-Aufbau ohne Bibliothek (06.10.2026), gemeinsam für die Firmenkunden-Konfiguratoren
 * (assets/kult-b2b-mischung.js, assets/kult-b2b-builder.js). Je Seite ein JPEG in voller A4-Größe (DCTDecode),
 * optional mit einer klickbaren Fläche (Link-Annotation). Dazu Hilfen: Bild laden, Canvas → Seite, Download und die
 * Kult-Box-Vorschau aus der Section „kult-b2b-logo-box“ der Seite (Foto, Schleife in der Logo-Farbe, Logo auf der Tüte).
 * window.KultPdf = { build(pages), loadImage(src, cors), pageFromCanvas(canvas, link), download(blob, name), composeBox(box, opts) }
 */
(function () {
  'use strict';
  if (window.KultPdf) return;

  /* pages: [{ jpeg: Uint8Array, w, h, link: { uri, rect: [x1, y1, x2, y2] } | null }] (rect in PDF-Punkten, Ursprung unten links) */
  function build(pages) {
    var parts = [], offsets = [], pos = 0;
    var push = function (x) {
      var bytes = x;
      if (typeof x === 'string') { bytes = new Uint8Array(x.length); for (var i = 0; i < x.length; i++) bytes[i] = x.charCodeAt(i) & 255; }
      parts.push(bytes);
      pos += bytes.length;
    };
    var obj = function (n, head, stream) {
      offsets[n] = pos;
      push(n + ' 0 obj\n' + head + '\n');
      if (stream) { push('stream\n'); push(stream); push('\nendstream\n'); }
      push('endobj\n');
    };
    var content = 'q 595.28 0 0 841.89 0 0 cm /Im0 Do Q';
    /* Objektnummern: 1 Katalog, 2 Seitenbaum, danach je Seite vier Nummern (Seite, Bild, Inhalt, Link) */
    var base = function (i) { return 3 + i * 4; };
    push('%PDF-1.4\n%\xE2\xE3\xCF\xD3\n');
    obj(1, '<< /Type /Catalog /Pages 2 0 R >>');
    obj(2, '<< /Type /Pages /Kids [' + pages.map(function (p, i) { return base(i) + ' 0 R'; }).join(' ') + '] /Count ' + pages.length + ' >>');
    pages.forEach(function (p, i) {
      var n = base(i);
      obj(n, '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 595.28 841.89] /Resources << /XObject << /Im0 ' + (n + 1) + ' 0 R >> >> /Contents ' + (n + 2) + ' 0 R' + (p.link ? ' /Annots [' + (n + 3) + ' 0 R]' : '') + ' >>');
      obj(n + 1, '<< /Type /XObject /Subtype /Image /Width ' + p.w + ' /Height ' + p.h + ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + p.jpeg.length + ' >>', p.jpeg);
      obj(n + 2, '<< /Length ' + content.length + ' >>', content);
      if (p.link) {
        var uri = String(p.link.uri).replace(/[\\()]/g, function (c) { return '\\' + c; });
        obj(n + 3, '<< /Type /Annot /Subtype /Link /Rect [' + p.link.rect.map(function (v) { return v.toFixed(2); }).join(' ') + '] /Border [0 0 0] /A << /S /URI /URI (' + uri + ') >> >>');
      } else obj(n + 3, '<< >>');
    });
    var count = 2 + pages.length * 4;
    var xref = pos;
    var table = 'xref\n0 ' + (count + 1) + '\n0000000000 65535 f \n';
    for (var k = 1; k <= count; k++) table += ('0000000000' + offsets[k]).slice(-10) + ' 00000 n \n';
    push(table + 'trailer\n<< /Size ' + (count + 1) + ' /Root 1 0 R >>\nstartxref\n' + xref + '\n%%EOF\n');
    return new Blob(parts, { type: 'application/pdf' });
  }

  function loadImage(src, cors) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      if (cors) img.crossOrigin = 'anonymous';
      img.decoding = 'async';
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(new Error('image')); };
      img.src = src;
    });
  }

  /* Canvas als JPEG-Seite; link = { uri, rect } oder canvas.kultLink */
  function pageFromCanvas(canvas, link) {
    var bin = window.atob(canvas.toDataURL('image/jpeg', 0.9).split(',')[1]);
    var jpeg = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) jpeg[i] = bin.charCodeAt(i);
    return { jpeg: jpeg, w: canvas.width, h: canvas.height, link: link || canvas.kultLink || null };
  }

  function download(blob, name) {
    var a = document.createElement('a');
    var url = URL.createObjectURL(blob);
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.setTimeout(function () { URL.revokeObjectURL(url); }, 20000);
  }

  function parseNums(str, n) {
    var p = String(str || '').split(',').map(function (x) { return parseFloat(x); });
    return p.length === n && p.every(function (x) { return isFinite(x); }) ? p : null;
  }

  /* Kult-Box-Vorschau als Canvas (höchstens 1400 px breit) aus der Section kult-b2b-logo-box der Seite.
     box: das Element <kult-b2b-logo-box>; opts { logo: Image|Canvas|null, color, scale, handle, name1, name2 }.
     Ohne Logo: das Standardbild der Section (Kult-Box aus dem Privatkunden-Bereich) oder das Foto. Ergebnis Promise<canvas|null>. */
  function composeBox(box, opts) {
    opts = opts || {};
    var frame = box ? box.querySelector('.kult-b2b-logo-box__frame') : null;
    if (!frame) return Promise.resolve(null);
    var srcOf = function (img) { return img ? (img.currentSrc || img.getAttribute('src') || '') : ''; };
    var big = function (u) { return u ? u.replace(/([?&])width=\d+/, '$1width=1400') : ''; };
    var fit = function (img) {
      var c = document.createElement('canvas');
      var k = Math.min(1, 1400 / img.naturalWidth);
      c.width = Math.round(img.naturalWidth * k); c.height = Math.round(img.naturalHeight * k);
      return c;
    };
    if (!opts.logo) {
      var def = big(srcOf(frame.querySelector('.kult-b2b-logo-box__default')) || srcOf(frame.querySelector(':scope > .kult-b2b-logo-box__photo')));
      if (!def) return Promise.resolve(null);
      return loadImage(def, true).then(function (img) {
        var c = fit(img);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        c.toDataURL('image/jpeg', 0.5); /* wirft bei gesperrtem Canvas, dann ohne Bild */
        return c;
      }).catch(function () { return null; });
    }
    /* Variante passend zum Kaffee (data-box-variant), sonst das Standardfoto der Section */
    var handle = String(opts.handle || '').toLowerCase();
    var variant = null;
    Array.prototype.forEach.call(frame.querySelectorAll('[data-box-variant]'), function (v) {
      if (!variant && handle && (',' + (v.dataset.boxVariant || '') + ',').indexOf(',' + handle + ',') > -1) variant = v;
    });
    var scope = variant || frame;
    var photo = big(srcOf(scope.querySelector(variant ? '.kult-b2b-logo-box__photo' : ':scope > .kult-b2b-logo-box__photo')));
    var mask = big(srcOf(scope.querySelector(variant ? '.kult-b2b-logo-box__ribbon-shade' : ':scope > .kult-b2b-logo-box__ribbon-shade')));
    var areaEl = frame.querySelector('[data-box-area]');
    var area = parseNums((variant && variant.dataset.area) || (areaEl ? areaEl.dataset.areaBase : ''), 4);
    var nameArea = variant ? parseNums(variant.dataset.nameArea, 4) : null;
    if (!photo) return Promise.resolve(null);
    var color = opts.color || (box.style.getPropertyValue('--ribbon-color') || '').trim() || getComputedStyle(box).getPropertyValue('--color-brand-gold').trim() || 'goldenrod';
    return Promise.all([loadImage(photo, true), mask ? loadImage(mask, true).catch(function () { return null; }) : Promise.resolve(null)]).then(function (imgs) {
      var img = imgs[0], maskImg = imgs[1];
      var c = fit(img);
      var ctx = c.getContext('2d');
      ctx.drawImage(img, 0, 0, c.width, c.height);
      if (maskImg) {
        /* Schleife: Farbfläche in der Form der Maske, darüber die Maske mit multiply für Falten und Schatten */
        var r = document.createElement('canvas');
        r.width = c.width; r.height = c.height;
        var rx = r.getContext('2d');
        rx.fillStyle = color;
        rx.fillRect(0, 0, r.width, r.height);
        rx.globalCompositeOperation = 'destination-in';
        rx.drawImage(maskImg, 0, 0, r.width, r.height);
        rx.globalCompositeOperation = 'multiply';
        rx.drawImage(maskImg, 0, 0, r.width, r.height);
        rx.globalCompositeOperation = 'destination-in';
        rx.drawImage(maskImg, 0, 0, r.width, r.height);
        ctx.drawImage(r, 0, 0);
      }
      if (area) {
        var ax = area[0] / 100 * c.width, ay = area[1] / 100 * c.height, aw = area[2] / 100 * c.width, ah = area[3] / 100 * c.height;
        var pad = c.width * 0.012;
        var lw = opts.logo.naturalWidth || opts.logo.width, lh = opts.logo.naturalHeight || opts.logo.height;
        var f = Math.min((aw - 2 * pad) / lw, (ah - 2 * pad) / lh) * (opts.scale || 1);
        var dw = lw * f, dh = lh * f;
        ctx.save();
        ctx.beginPath(); ctx.rect(ax, ay, aw, ah); ctx.clip();
        ctx.globalCompositeOperation = 'multiply';
        ctx.drawImage(opts.logo, ax + (aw - dw) / 2, ay + (ah - dh) / 2, dw, dh);
        ctx.restore();
      }
      if (nameArea) {
        var nx = nameArea[0] / 100 * c.width, ny = nameArea[1] / 100 * c.height, nw = nameArea[2] / 100 * c.width, nh = nameArea[3] / 100 * c.height;
        var l1 = String(opts.name1 || 'Ihre Firma').toUpperCase(), l2 = String(opts.name2 || 'Mischung').toUpperCase();
        var size = nh / 2.3;
        var fam = getComputedStyle(box).getPropertyValue('--font-body').trim() || 'Helvetica, Arial, sans-serif';
        ctx.font = '800 ' + size + 'px ' + fam;
        var widest = Math.max(ctx.measureText(l1).width, ctx.measureText(l2).width);
        if (widest > nw) { size = size * nw / widest; ctx.font = '800 ' + size + 'px ' + fam; }
        ctx.fillStyle = 'white';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(l1, nx + nw / 2, ny + nh / 2 - size * 0.56);
        ctx.fillText(l2, nx + nw / 2, ny + nh / 2 + size * 0.56);
      }
      c.toDataURL('image/jpeg', 0.5); /* wirft bei gesperrtem Canvas, dann ohne Bild */
      return c;
    }).catch(function () { return null; });
  }

  window.KultPdf = { build: build, loadImage: loadImage, pageFromCanvas: pageFromCanvas, download: download, composeBox: composeBox };
})();
